import TripContainer from './TripContainer';

export default TripContainer;
